export function buildArtworkRequestKey(endpoint, viewerSessionId) {
  return JSON.stringify([
    typeof endpoint === "string" ? endpoint : "",
    viewerSessionId ?? "guest",
  ]);
}

export function beginArtworkRequest(requestRef, requestKey) {
  if (requestRef.current?.key === requestKey) {
    return null;
  }

  const requestToken = Symbol("artwork-request");
  requestRef.current = { key: requestKey, requestToken };
  return requestToken;
}

export function isCurrentArtworkRequest(requestRef, requestToken) {
  return requestRef.current?.requestToken === requestToken;
}

export function finishArtworkRequest(requestRef, requestToken) {
  if (isCurrentArtworkRequest(requestRef, requestToken)) {
    requestRef.current = null;
  }
}
